import React, {Component} from 'react'
import PrintPreview from '../PrintPreview'
import PdfStore from '../../../stores/PdfStore'

var NotificationSystem = require('react-notification-system');
const DEFAUT_ROW = 18
class PrintBNPDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,data:{itemlist:this.newEmptyRow(DEFAUT_ROW)},page_title:'กำลังดึงข้อมูล..',dataPage:[{page:0},{page:1}],defaultTypePrint:'3'}
    
    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
    this.loadData()
  }

  newEmptyRow(number){
  	let emptyRow = {}
  	if (this.props.doc==='invoice_doc')
  		emptyRow = {amount:'',bf_invoice_item_id:'',detail:'',discount:'',invoice_no:'',price_per_unit:'',quantity:'',seq:''}
  	else if (this.props.doc==='taxinvoice_doc')
  		emptyRow = {amount:'',bf_taxinvoice_item_id:'',detail:'',discount:'',taxinvoice_no:'',price_per_unit:'',quantity:'',seq:''}

    return new Array(number).fill(null).map((item,index)=>{
      return emptyRow
    })
  }

  loadData() {
  	let {data} = this.state
  	this.setState({loading:true})
 	PdfStore.loadBNPDoc(this.props.doc,this.props.param,this.props.docNo,(result)=>{
 		data = result.data
 		if (data.itemlist!==undefined&&data.itemlist.length>0)
 			data.itemlist = data.itemlist.concat(this.newEmptyRow(DEFAUT_ROW-data.itemlist.length))

 		this.setState({loading:true,data:data})
 	})
  }

  renderLogoUrl(logoUrl){
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    if(logoUrl!==undefined)
      return (<img src={imgUrl} />)
    else
      return ('')
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummaryDiscount() {
  	let {data} = this.state
  	let sum = 0
  	data.itemlist.forEach(function(item,index) {
  		let discount = item.discount
  		if (discount===''||discount===null||discount===undefined||isNaN(discount))
  			discount = 0

  		sum += parseFloat(discount)
  	})
  	return sum
  }

  getSummaryAmount() {
  	let {data} = this.state
  	let sum = 0
  	data.itemlist.forEach(function(item,index) {
  		let amount = item.amount
  		if (amount===''||amount===null||amount===undefined||isNaN(amount))
  			amount = 0
  		
  		sum += parseFloat(amount)
  	})
  	sum = sum - this.getSummaryDiscount()
  	return sum
  }

  getVat() {
  	let {data} = this.state
  	let sum = 0
  	if (data.vat_type==='VAT_EXCLUDE') {
  		sum = (this.getSummaryAmount()*7)/100
  		return sum
  	} else {
  		return sum
  	}
  }

  getDiscountPercent(discount=0,amount=0) {
  	let sum = (discount*100)/amount
  	return sum
  }

  renderSignature() {
    let {data} = this.state
    return(
        <table className='table table-print-bnp-invoice-doc print-bnp-invoice-signature' style={{marginTop:'-20px'}}>
	        <tbody>
	          <tr>
	          	<td className='bt-h text-center' style={{width:'25%'}}>
	          		<div className='font-small'>ได้รับสินค้าตามรายการข้างบนนี้ไว้ถูกต้องและอยู่ในสภาพเรียบร้อยทุกประการ</div>
                <br style={{lineHeight:'1.4'}}/>
	          		.............................................
	          		<br/>
	          		ลูกค้าผู้รับบริการ
	          		<br/>
	          		.............../.............../.............
	          	</td>
	          	<td className='bt-h text-center' style={{width:'25%'}}>
	          		<br/>
	          		<br/>
	          		<br/>
	          		.............................................
	          		<br/>
	          		ผู้จัดการ
	          		<br/>
	          		.............../.............../.............
	          	</td>
	          	<td className='bt-h text-center' style={{width:'25%'}}>
	          		<br/>
	          		<br/>
	          		<br/>
	          		.............................................
	          		<br/>
	          		ผู้รับเงิน
	          		<br/>
	          		.............../.............../.............
	          	</td>
	          	<td className='bt-h text-center' style={{width:'25%'}}>
	          		<br/>
	          		<br/>
	          		<br/>
	          		.............................................
	          		<br/>
	          		ผู้ตรวจสอบ/บัญชี
	          		<br/>
	          		.............../.............../.............
	          	</td>
	          </tr>
	        </tbody>
	    </table>      
    )
  }

  renderBody() {
    let {data} = this.state
    return(
      <div>
      	<div style={{width:'100%'}}>
      	  <div className='bnp-doc-customer-box' style={{width:'74.5%',float:'left',border:'1px solid #111',borderRadius:'8px',marginBottom:'10px',height:'131.5px'}}>
	        <table className='table table-print-bnp-invoice-doc-head' style={{marginTop:'10px'}}>
	          <tbody>
	            <tr>
	              <td colSpan={2}>ชื่อลูกค้า {data.customer_name===null||data.customer_name===undefined?'':data.customer_name}</td>
	            </tr>
	            <tr>
	              <td colSpan={2}>ที่อยู่ {data.customer_address===null||data.customer_address===undefined?'':data.customer_address}</td>
	            </tr>
	            <tr>
	              <td colSpan={2}>โทรศัพท์ {data.customer_tel===null||data.customer_tel===undefined?'':data.customer_tel}</td>
	            </tr>
	            <tr>
	              <td style={{width:'50%'}}>เลขประจำตัวผู้เสียภาษี {data.customer_tax===null||data.customer_tax===undefined?'':data.customer_tax}</td>
	              <td style={{width:'50%'}}>สาขา {data.customer_branch===null||data.customer_branch===undefined?'':data.customer_branch}</td>
	            </tr>
	          </tbody>
	        </table>
	      </div>
	      <div style={{width:'24.5%',float:'right',border:'1px solid #111',borderRadius:'8px',marginBottom:'10px'}}>
	      	<table className='table table-print-bnp-invoice-doc' style={{marginTop:'5px',marginBottom:'5px'}}>
	          <tbody>
	            <tr>
	              <td className='fixed-line-height bt-h bl-h br-h'>วันที่ {data.doc_date===null||data.doc_date===undefined?'':data.doc_date}</td>
	            </tr>
	            <tr>
	              <td className='fixed-line-height bl-h br-h'>เลขที่ {data.doc_no===null||data.doc_no===undefined?'':data.doc_no}</td>
	            </tr>
	            <tr>
	              <td className='fixed-line-height bl-h br-h'>เลขที่ JOB {data.worklist===null||data.worklist===undefined?'':data.worklist}</td>
	            </tr>
	            <tr>
	              <td className='fixed-line-height bb-h bl-h br-h'>อ้างใบแจ้งหนี้เลขที่</td>
	            </tr>
	          </tbody>
	        </table>
	      </div>
	    </div>      
	    <div>
        	{this.renderDoc()}
        </div>	
        <div>
        	{this.renderTable()}
        	{this.renderSignature()}
        </div>
      </div>
    )
  }

  renderTable() {
  	let {data} = this.state
  	return(
  		<table className='table table-print-bnp-invoice-doc'>
	        <tbody>
	          <tr>
	            <td style={{width:'5%'}} className='text-center'>ลำดับ</td>
	            <td style={{width:'40%'}} className='text-center'>รายการ</td>
	            <td style={{width:'10%'}} className='text-center'>จำนวน</td>
	            <td style={{width:'12%'}} className='text-center'>ราคา/หน่วย</td>
	            <td style={{width:'10%'}} className='text-center'>ลด %</td>
	            <td style={{width:'10%'}} className='text-center'>ส่วนลด</td>
	            <td style={{width:'13%'}} className='text-center'>จำนวนเงิน</td>
	          </tr>
	          {this.renderRowData()}
	          <tr>
	          	<td className='br-h' colSpan={3}>หมายเหตุ</td>
	            <td className='bb-h'>ส่วนลด</td>
	            <td colSpan={2} className='text-right'>{this.getNumberFormat(this.getSummaryDiscount())}</td>
	            <td className='text-right'>{this.getNumberFormat(this.getSummaryAmount())}</td>
	          </tr>
	          <tr>
	          	<td className='bt-h br-h' colSpan={3}>{'จำนวนเงิน '+(data.grand_total_thai===''||data.grand_total_thai===null||data.grand_total_thai===undefined?'( ศูนย์บาทถ้วน )':'( '+data.grand_total_thai+' )')}</td>
	            <td className='br-h' colSpan={2}>ภาษีมูลค่าเพิ่ม VAT 7%</td>
	            <td className='text-right'></td>
	            <td className='text-right'>{this.getNumberFormat(this.getVat())}</td>
	          </tr>
	          <tr>
	          	<td className='bt-h br-h' colSpan={3}></td>
	            <td className='bt-h br-h' colSpan={2}>ภาษีมูเงินสุทธิ </td>
	            <td className='bt-h text-right'></td>
	            <td className='text-right'>{this.getNumberFormat(data.amount)}</td>
	          </tr>
	        </tbody>
	    </table>
  	)
  }

  renderRowData() {
  	let {data} = this.state
  	return(
  		data.itemlist.map((item,index)=>{
  			return(
  				<tr key={index}>
  					<td className={'text-center '+(index>0?'bt-h':'')}>{item.seq===''?<br/>:index+1}</td>
  					<td className={index>0?'bt-h':''}>{item.seq===''?'':item.detail}</td>
  					<td className={'text-center '+(index>0?'bt-h':'')}>{item.seq===''||item.quantity==='0'||item.quantity===''?'':this.getNumberFormat(item.quantity)}</td>
  					<td className={'text-right '+(index>0?'bt-h':'')}>{item.seq===''||item.quantity==='0'||item.quantity===''?'':this.getNumberFormat(item.price_per_unit)}</td>
  					<td className={'text-right '+(index>0?'bt-h':'')}>{item.seq===''||item.quantity==='0'||item.quantity===''?'':this.getNumberFormat(this.getDiscountPercent(item.discount,item.amount))}</td>
  					<td className={'text-right '+(index>0?'bt-h':'')}>{item.seq===''||item.quantity==='0'||item.quantity===''?'':this.getNumberFormat(item.discount)}</td>
  					<td className={'text-right '+(index>0?'bt-h':'')}>{item.seq===''||item.quantity==='0'||item.quantity===''?'':this.getNumberFormat(item.amount)}</td>
  				</tr>
  			)
  		})
  	)
  }

  renderDoc() {
    let {data} = this.state
    return(
      <table className='table table-print-bnp-invoice-doc' style={{marginBottom:'10px'}}>
        <tbody>
          <tr>
            <td style={{width:'15%'}} className='text-center'>ยี่ห้อรถ</td>
            <td style={{width:'15%'}} className='text-center'>รุ่นรถ</td>
            <td style={{width:'20%'}} className='text-center'>เลขเครื่อง</td>
            <td style={{width:'20%'}} className='text-center'>เลขตัวถัง</td>
            <td style={{width:'20%'}} className='text-center'>ทะเบียน</td>
            <td style={{width:'10%'}} className='text-center'>สีรถ</td>
          </tr>
          <tr>
          	<td className='text-center'>{data.car===undefined||data.car.brand===''||data.car.brand===null||data.car.brand===undefined?<br/>:data.car.brand}</td>
            <td className='text-center'>{data.car===undefined||data.car.model===null||data.car.model===undefined?'':data.car.model}</td>
            <td className='text-center'>{data.car===undefined||data.car.engine_no===null||data.car.engine_no===undefined?'':data.car.engine_no}</td>
            <td className='text-center'>{data.car===undefined||data.car.chassis_no===null||data.car.chassis_no===undefined?'':data.car.chassis_no}</td>
            <td className='text-center'>{data.car===undefined||data.car.car_registration_no===null||data.car.car_registration_no===undefined?'':data.car.car_registration_no}</td>
            <td className='text-center'>{data.car===undefined||data.car.car_color===null||data.car.car_color===undefined?'':data.car.car_color}</td>
          </tr>
        </tbody>
      </table>    
    )
  } 

  renderComponentPage(page,index) {
    let {data,defaultTypePrint} = this.state

    return(
      <div className='font-print' key={index}>
        <div style={{display:defaultTypePrint==='2'||page===1?'none':''}}>
          <div>
	        <header>
	          <h2 className="text-right">{this.props.title}</h2>
	          <br/>
	          <div>(เอกสารออกเป็นชุด)</div>
	        </header>  
	        <article className={"article-company "+data.logo_class}>
	          <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
	            {this.renderLogoUrl(data.logo_url)}
	          </div>
	          <section className="font-16" style={{width:'85%',paddingTop:(data.logo_class=='bg-logo-absolute'?'0px':'0')}}>
	            <strong>
	              <p style={{lineHeight:'0.7'}}>{data.company_name} (สำนักงานใหญ่)</p>           
	              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
	              <p style={{lineHeight:'0.7'}}>เลขประจำตัวผู้เสียภาษีอากร {data.company_tax} โทร {data.company_tel}</p>              
	            </strong>
	          </section>
	          <section className='text-right sec-copy-doc'>
  			      <span style={{display:defaultTypePrint==='0'?'none':''}}>ต้นฉบับ</span>
              <p style={{display:data.deleted==='1'?'':'none'}} className='p-copy-doc'>ยกเลิก</p>
  		      </section>
	        </article>
	        {this.renderBody()}
	      </div>
	    </div>    
	    <div style={{display:defaultTypePrint==='1'||page===0?'none':''}}>
	      <div>
	        <header>
	          <h2 className="text-right">{this.props.title}</h2>
	          <br/>
	          <div>(เอกสารออกเป็นชุด)</div>
	        </header>  
	        <article className={"article-company "+data.logo_class}>
	          <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
	            {this.renderLogoUrl(data.logo_url)}
	          </div>
	          <section className="font-16" style={{width:'85%',paddingTop:(data.logo_class=='bg-logo-absolute'?'0px':'0')}}>
	            <strong>
	              <p style={{lineHeight:'0.7'}}>{data.company_name} (สำนักงานใหญ่)</p>           
	              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
	              <p style={{lineHeight:'0.7'}}>เลขประจำตัวผู้เสียภาษีอากร {data.company_tax} โทร {data.company_tel}</p>              
	            </strong>
	          </section>
	          <section className='text-right sec-copy-doc'>
			        <span style={{display:defaultTypePrint==='0'?'none':''}}>สำเนา</span>
              <p style={{display:data.deleted==='1'?'':'none'}} className='p-copy-doc'>ยกเลิก</p>
		        </section>
	        </article>
	        {this.renderBody()}
	      </div>
	  	</div>    
      </div>  
    )
  }

  onTypePrintChange(e) {
  	let {dataPage} = this.state
  	if (e==='1')
  	  dataPage = [{page:0}]
  	else if (e==='2')
  	  dataPage = [{page:1}]
  	else
  	  dataPage = [{page:0},{page:1}]	

  	this.setState({defaultTypePrint:e,dataPage:dataPage})
  }

  render() {
    let {loading,dataPage} = this.state
    return(
      <div>
        <PrintPreview
            loading={loading}
            leftBarTitle={this.props.title}
            onTypePrintChange={this.onTypePrintChange.bind(this)}
        		defaultTypePrint={this.state.defaultTypePrint}
        		showPageNumber={false}
          >
            {
              dataPage.map((item,index)=> {
            	return this.renderComponentPage(item.page,index)
              })	
            }
        </PrintPreview>
        <NotificationSystem ref="notificationSystem" />
      </div>
    ) 
  }
}  

PrintBNPDoc.defaultProps = {
  title: 'สำหรับลูกค้า',  
  mode: '1'
}
export default PrintBNPDoc;


// WEBPACK FOOTER //
// ./src/view/print/bnp/PrintBNPDoc.js